import { useMutation } from '@gogame/query';

import { updatePermissions } from '../../sources/partner-users';
import { updateUsersPermissions } from '../queryKeyFactory';

export const useUpdatePermissions = () => {
  const updateMutation = useMutation(
    updateUsersPermissions(),
    updatePermissions,
    {
      successMessage: () => 'Users Permissions Updated',
    }
  );
  return [updateMutation.mutateAsync, updateMutation];
};
